<lib-dismounting-dummy-pallet [dismountingPalletInformation]="dismountingPalletInformation"></lib-dismounting-dummy-pallet>
<lib-modal-footer
  [submitLabel]="'DISMOUNTING.DISMOUNT'"
  (submitClicked)="dismountContainer()"
  (declineClicked)="onCloseModal()"
  [whenLoadingTopic]="LOADING_TOPIC"
></lib-modal-footer>
